"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var React = _interopRequireWildcard(_react);

var _tcomb = require("tcomb");

var t = _interopRequireWildcard(_tcomb);

var _lodash = require("lodash");

var _ = _interopRequireWildcard(_lodash);

var _selectn = require("selectn");

var _selectn2 = _interopRequireDefault(_selectn);

var _tcombForm = require("tcomb-form");

var form = _interopRequireWildcard(_tcombForm);

var _AppDataField = require("../AppDataField");

var _actions = require("../actions");

var reportDetailActions = _interopRequireWildcard(_actions);

var _ReportDetailAddOptionModal = require("../../../containers/reportDetail/ReportDetailAddOptionModal");

var _ReportDetailAddOptionModal2 = _interopRequireDefault(_ReportDetailAddOptionModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ChoiceAppDataField = function ChoiceAppDataField(dataField, contentDataField) {
    var _this = this;

    var isWithinTable = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];

    _classCallCheck(this, ChoiceAppDataField);

    this.choices = [];
    this.freeTextSchema = function () {
        return t.struct(_defineProperty({}, "freeText" + _this.dataField.uid, t.refinement(t.String, function (n) {
            if (_this.dataField.freetextMaxLength) {
                return n.length <= _this.dataField.freetextMaxLength;
            } else {
                return n.length > 0;
            }
        })));
    };
    this.key = function () {
        return _this.dataField.uid;
    };
    this.setValue = function (value) {
        value = value || null;
        if (_.isArray(value)) {
            _.set(_this, "contentDataField.data.choices", value);
        } else if (value) {
            _.set(_this, "contentDataField.data.choices", Array(value));
        } else {
            _.set(_this, "contentDataField.data.choices", null);
        }
    };
    this.currentFormValue = function () {
        var value = (0, _selectn2.default)("data.choices", _this.contentDataField);
        return value;
    };
    this.freeTextValues = function () {
        var value = (0, _selectn2.default)("data.freeTextValues", _this.contentDataField);
        if (!value) {
            return [];
        } else if (!_.isArray(value)) {
            return [value];
        }
        return value;
    };
    this.addFreeTextValues = function (newVals) {
        _.set(_this.contentDataField, "data.freeTextValues", _this.freeTextValues().concat(newVals));
    };
    this.appSchemaObject = function () {
        var options = {};
        _.set(options, _this.key(), _this.dataField.isMandatory ? t.refinement(t.list(t.String), function (n) {
            return n ? n.length > 0 : false;
        }) : t.maybe(t.list(t.String)));
        return options;
    };
    this.appSchemaStruct = function () {
        return t.struct(_this.appSchemaObject(), _this.dataField.uid);
    };
    this.appSchemaFieldOptions = function (formattedMessage) {
        var disabled = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];

        var fields = {};
        var choices = _.chain(_this.dataField.choices).map(function (choice) {
            return {
                text: choice,
                value: choice
            };
        }).value();
        if (_this.dataField.isFreetextAllowed) {
            // the clean way: any freetext value that was entered is stored in the field
            // add it to the available choices (even if it is not selected currently)
            var freeTextValues = _this.freeTextValues();
            choices = choices.concat(_.map(freeTextValues, function (val) {
                return { text: val, value: val };
            }));
            // also accept current Values as options to allow additional free text entries
            // necessary for older reportcontents before storing freetext values inside the field
            var currentValues = _this.currentFormValue();
            if (currentValues) {
                if (!_.isArray(currentValues)) {
                    currentValues = [currentValues];
                }
                var freetextSelected = _.differenceWith(currentValues, choices, function (cur, ex) {
                    return cur === ex.text;
                });
                choices = choices.concat(_.map(freetextSelected, function (value) {
                    return { text: value, value: value };
                }));
                _this.addFreeTextValues(freetextSelected);
            }
        }
        _.set(fields, _this.key(), {
            label: (0, _AppDataField.labelHelper)(_this.dataField.title, _this.dataField.isMandatory, _this.isWithinTable, formattedMessage),
            options: choices,
            help: (0, _AppDataField.helpContainer)(true, _this.dataField.description),
            factory: form.form.Select,
            template: _this.template,
            disabled: disabled
        });
        _this.choices = choices;
        return fields;
    };
    this.template = function (locals) {
        locals.attrs.size = _this.choices.length + 1;
        return React.createElement("div", { style: { "width": _AppDataField.containerWidth } }, form.form.Form.templates.select.clone()(locals), function () {
            if (_this.dataField.isFreetextAllowed) {
                return React.createElement(_ReportDetailAddOptionModal2.default, { disabled: locals.disabled, maxLength: _this.dataField.freetextMaxLength, addItem: _this.addItem, schema: _this.freeTextSchema(), dataFieldUid: _this.dataField.uid });
            }
        }());
    };
    this.dispatchUpdate = function (dispatch) {
        // saves report when adding new option
        dispatch(reportDetailActions.updateReportWithAppDataField(_this)).then(function (value) {
            dispatch(reportDetailActions.saveSelectedReport());
        });
    };
    this.addItem = function (dispatch, text) {
        _this.addFreeTextValues([text]);
        var currentValues = _this.currentFormValue();
        if (currentValues) {
            currentValues = currentValues.concat(Array(text));
        } else {
            currentValues = Array(text);
        }
        _this.setValue(currentValues);
        _this.dispatchUpdate(dispatch);
    };
    this.copy = function () {
        return new ChoiceAppDataField(_this.dataField, _this.contentDataField);
    };
    this.contentDataField = contentDataField;
    this.dataField = dataField;
    this.contentDataField = Object.assign({}, contentDataField, {
        type: "choice",
        uid: dataField.uid
    });
    this.isWithinTable = isWithinTable;
    this.setValue(this.currentFormValue());
};

exports.default = ChoiceAppDataField;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/reducers/reportDetail/fields/ChoiceAppDataField.tsx
 ** module id = 1292
 ** module chunks = 0
 **/